(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('CreateTargetAudienceController', CreateTargetAudienceController);

    /** @ngInject */
    function CreateTargetAudienceController($uibModalInstance, TargetAudienceService, toastr, $translate, $timeout,
                                            targetAudienceId, isViewMode, FILTER_GROUP, FILTER_CSS_CLASS, moment) {
        var vm = this;

        var DATE_FORMAT = $translate.instant('momentDateFormat');

        vm.isViewMode = isViewMode;

        vm.FILTER_GROUP = FILTER_GROUP;
        vm.FILTER_CSS_CLASS = FILTER_CSS_CLASS;
        vm.isSubmitting = false;

        vm.targetAudience = {
            name: "",
            filters: [
                [
                    {
                        field: null,
                        operator: null,
                        value: null,
                        startValue: null,
                        endValue: null,
                        group: null
                    }
                ]
            ]
        };

        vm.allOptions = null;

        vm.fieldLabels = {
            GENDER: $translate.instant('campaign.new.public-info.create-modal.field-labels.GENDER'),
            BIRTHDATE: $translate.instant('campaign.new.public-info.create-modal.field-labels.BIRTHDATE'),
            AGE: $translate.instant('campaign.new.public-info.create-modal.field-labels.AGE'),
            CREATED_DATE: $translate.instant('campaign.new.public-info.create-modal.field-labels.CREATED_DATE'),
            TYPE: $translate.instant('campaign.new.public-info.create-modal.field-labels.TYPE'),
            SELLER: $translate.instant('campaign.new.public-info.create-modal.field-labels.SELLER'),
            TAG: $translate.instant('campaign.new.public-info.create-modal.field-labels.TAG'),
            SALES_FUNNEL: $translate.instant('campaign.new.public-info.create-modal.field-labels.SALES_FUNNEL'),
            NEGOTIATION_VALUE: $translate.instant('campaign.new.public-info.create-modal.field-labels.NEGOTIATION_VALUE'),
            PURCHASE_VALUE: $translate.instant('campaign.new.public-info.create-modal.field-labels.PURCHASE_VALUE'),
            LATEST_TRANSACTION_DATE: $translate.instant('campaign.new.public-info.create-modal.field-labels.LATEST_TRANSACTION_DATE'),
            AVERAGE_TRANSACTION_VALUE: $translate.instant('campaign.new.public-info.create-modal.field-labels.AVERAGE_TRANSACTION_VALUE'),
            PURCHASE_CATEGORY: $translate.instant('campaign.new.public-info.create-modal.field-labels.PURCHASE_CATEGORY')
        };

        vm.operatorLabels = {
            EQUALS: $translate.instant('campaign.new.public-info.create-modal.operator-labels.EQUALS'),
            NOT_EQUALS: $translate.instant('campaign.new.public-info.create-modal.operator-labels.NOT_EQUALS'),
            IS_GREATER_THAN_OR_EQUAL: $translate.instant('campaign.new.public-info.create-modal.operator-labels.IS_GREATER_THAN_OR_EQUAL'),
            IS_LESS_THAN_OR_EQUAL: $translate.instant('campaign.new.public-info.create-modal.operator-labels.IS_LESS_THAN_OR_EQUAL'),
            BETWEEN: $translate.instant('campaign.new.public-info.create-modal.operator-labels.BETWEEN')
        };

        vm.optionLabels = {
            MALE: $translate.instant('campaign.new.public-info.create-modal.option-labels.MALE'),
            FEMALE: $translate.instant('campaign.new.public-info.create-modal.option-labels.FEMALE'),
            OTHERS: $translate.instant('campaign.new.public-info.create-modal.option-labels.OTHERS'),
            INDIVIDUAL: $translate.instant('campaign.new.public-info.create-modal.option-labels.INDIVIDUAL'),
            COMPANY: $translate.instant('campaign.new.public-info.create-modal.option-labels.COMPANY'),
            WITH_SELLER_RELATIONSHIP: $translate.instant('campaign.new.public-info.create-modal.option-labels.WITH_SELLER_RELATIONSHIP'),
            NOT_SELLER_RELATIONSHIP: $translate.instant('campaign.new.public-info.create-modal.option-labels.NOT_SELLER_RELATIONSHIP'),
            ALL: $translate.instant('campaign.new.public-info.create-modal.option-labels.ALL'),
            CATEGORY_NOT_FOUND : $translate.instant('campaign.new.public-info.create-modal.option-labels.CATEGORY_NOT_FOUND_IN_STORE')
        };

        vm.groupsOptions = [
            {
                label: $translate.instant('campaign.new.public-info.create-modal.characteristic'),
                icon: 'fa fa-users',
                value: 'CHARACTERISTIC'
            },
            {
                label: $translate.instant('campaign.new.public-info.create-modal.behavior'),
                icon: 'fa fa-users',
                value: 'BEHAVIOR'
            }
        ];

        vm.close = function () {
            $uibModalInstance.close();
        };

        init();

        function init() {
            if (targetAudienceId && vm.isViewMode) {
                TargetAudienceService.findById(targetAudienceId, $translate.use()).then(function (response) {
                    vm.targetAudience = response.data.targetAudience;
                    vm.targetAudience.filters = response.data.parsedFilters;

                    formatLoadedFilters(vm.targetAudience.filters);
                });
            }
            getFiltersOptions();
        }

        function formatLoadedFilters(filters) {
            var filterDateFields = ["CREATED_DATE", "BIRTHDATE", "LATEST_TRANSACTION_DATE"];
            filters.forEach(function (group) {
                group.forEach(function (filter) {
                    if (filter.value && vm.optionLabels[filter.value]) {
                        filter.value = vm.optionLabels[filter.value];
                    } else if (filter.value && filterDateFields.includes(filter.field)) {
                        if (filter.operator === "BETWEEN") {
                            var parts = filter.value.split(";");
                            filter.startValue = parts[0] ? moment(parts[0]).format(DATE_FORMAT).toString() : null;
                            filter.endValue = parts[1] ? moment(parts[1]).format(DATE_FORMAT).toString() : null;
                        } else {
                            filter.value = moment(filter.value).format(DATE_FORMAT).toString();
                        }
                    } else if (filter.value && filter.operator === "BETWEEN") {
                        var parts = filter.value.split(";");
                        filter.startValue = parts[0] ? parseFloat(parts[0]) : null;
                        filter.endValue = parts[1] ? parseFloat(parts[1]) : null;
                    }

                    if (filter.field && vm.fieldLabels[filter.field]) {
                        filter.field = vm.fieldLabels[filter.field];

                        if (filter.field === vm.fieldLabels.PURCHASE_CATEGORY && filter.value === null) {
                            filter.value = vm.optionLabels.CATEGORY_NOT_FOUND;
                        }

                    }

                    if (filter.operator && vm.operatorLabels[filter.operator]) {
                        filter.operator = vm.operatorLabels[filter.operator];
                    }
                });
            });
        }

        function getFiltersOptions() {
            TargetAudienceService.getAllFilters($translate.use()).then(function (response) {
                vm.allOptions = response.data;
                vm.filterOptions = {
                    'CHARACTERISTIC': vm.mapFilterOptions('CHARACTERISTIC'),
                    'BEHAVIOR': vm.mapFilterOptions('BEHAVIOR')
                };
                if (vm.isViewMode) {
                    var purchaseCategoryLabel = vm.fieldLabels.PURCHASE_CATEGORY;
                    vm.filterOptions.BEHAVIOR[purchaseCategoryLabel].options.push(vm.optionLabels.CATEGORY_NOT_FOUND);
                }
            }, function (){
                toastr.error($translate.instant("campaign.new.public-info.toast.load-filters-error"));
            });
        }

        vm.onFieldChange = function (filter) {
            filter.operator = null;
            filter.value = null;
            filter.startValue = null;
            filter.endValue = null;

            $timeout(function () {
                if (vm.filterOptions[filter.group][filter.field].hideOperators) {
                    filter.operator = vm.filterOptions[filter.group][filter.field].operators[0];
                }
            }, 0);
        };

        vm.onOperatorChange = function (filter) {
            filter.value = null;
            filter.startValue = null;
            filter.endValue = null;
        };

        vm.onValueChange = function (filter, groupIndex, propIndex) {

            $timeout(function () {
                if ((filter.field === vm.fieldLabels.NEGOTIATION_VALUE || filter.field === vm.fieldLabels.PURCHASE_VALUE
                        || filter.field === vm.fieldLabels.AVERAGE_TRANSACTION_VALUE)
                    && filter.operator === vm.operatorLabels.BETWEEN) {
                    var startValue = filter.startValue;
                    var endValue = filter.endValue;
                    var modelName = 'valueCurrencyEnd' + groupIndex + '-' + propIndex;
                    var field = vm.targetAudienceForm[modelName];

                    if (field) {
                        if (startValue === endValue) {
                            field.$setValidity("duplicatedValue", false);
                            field.$setValidity("maxValue", true);
                        } else if (startValue < endValue) {
                            field.$setValidity("duplicatedValue", true);
                            field.$setValidity("maxValue", true);
                        } else {
                            field.$setValidity("duplicatedValue", true);
                            field.$setValidity("maxValue", false);
                        }
                    }
                }
            }, 0);
        };

        vm.markAllFieldsTouched = function () {
            angular.forEach(vm.targetAudienceForm, function (field, key) {
                if (key[0] !== '$' && field.$setTouched) {
                    field.$setTouched();
                }
            });
        };

        vm.mapFilterOptions = function (groupSelected) {
            var options = vm.allOptions;
            var mapped = {};
            for (var key in options) {
                if (options.hasOwnProperty(key) && options[key]) {
                    if (options[key].group === groupSelected) {
                        var newKey = vm.fieldLabels[key] || key;
                        mapped[newKey] = {
                            input: options[key].input || "",
                            operators: (options[key].operators || []).map(function (op) {
                                return vm.operatorLabels[op] || op;
                            }),
                            hideOperators: options[key].hideOperators || false,
                            options: options[key].options
                                ? options[key].options.map(function (opt) {
                                    return vm.optionLabels[opt] || opt;
                                })
                                : undefined
                        };
                    }
                }
            }
            return mapped;
        };

        function mapValuesToOriginal(values) {
            var reverseFieldLabels = Object.keys(vm.fieldLabels).reduce(function(acc, key) {
                acc[vm.fieldLabels[key]] = key;
                return acc;
            }, {});

            var reverseOperatorLabels = Object.keys(vm.operatorLabels).reduce(function(acc, key) {
                acc[vm.operatorLabels[key]] = key;
                return acc;
            }, {});

            var reverseOptionLabels = Object.keys(vm.optionLabels).reduce(function(acc, key) {
                acc[vm.optionLabels[key]] = key;
                return acc;
            }, {});

            function formatDate(value, inputType) {
                if (!value && value !== 0) return null;

                if (inputType !== 'DATE') return value;
                var date = moment(value, DATE_FORMAT).toDate();
                return isNaN(date.getTime()) ? value : date.toISOString().slice(0, 10);
            }

            values = removeFiltersWithNullField(values);

            return values.map(function(group) {
                return group.map(function(filter) {
                    if (filter.field) {
                        var inputType = vm.filterOptions[filter.group][filter.field].input;

                        if (filter.operator === vm.operatorLabels.BETWEEN) {
                            filter.value = formatDate(filter.startValue, inputType) + ";" + formatDate(filter.endValue, inputType);
                        } else {
                            filter.value = formatDate(filter.value, inputType);
                        }

                        return {
                            field: reverseFieldLabels[filter.field] || filter.field,
                            operator: reverseOperatorLabels[filter.operator] || filter.operator,
                            value: reverseOptionLabels[filter.value] || filter.value
                        };
                    }
                });
            });
        }

        function removeFiltersWithNullField(nestedFilters) {
            return nestedFilters
              .map(function (filterList) {
                  return filterList.filter(function (filter) {
                      return filter.field !== null;
                  });
              })
              .filter(function (filteredList) {
                  return filteredList.length > 0;
              });
        }

        vm.canAddNewGroup = function () {
            if (vm.targetAudience.filters.length === 0) return true;
            return vm.targetAudience.filters.every(function (group) {
                return group.length > 0 && group.every(function (filter) {
                    if (!filter.field || !filter.operator) return false;

                    if (filter.operator === vm.operatorLabels.BETWEEN) {
                        return filter.startValue && filter.endValue;
                    }

                    return filter.value;
                });
            });
        };

        vm.canAddNewFilter = function (groupIndex) {
            return vm.targetAudience.filters[groupIndex].every(function (filter) {
                if (!filter.field || !filter.operator) return false;

                if (filter.operator === vm.operatorLabels.BETWEEN) {
                    return filter.startValue && filter.endValue;
                }

                return filter.value;
            });
        };

        vm.addNewFilterGroup = function () {
            if (!vm.canAddNewGroup()) {
                vm.markAllFieldsTouched();
                return;
            }
            vm.targetAudience.filters.push([
                {
                    field: null,
                    operator: null,
                    value: null
                }
            ]);
        };

        vm.deleteFilterGroup = function (groupIndex) {
            if (vm.targetAudience.filters[groupIndex]) {
                vm.targetAudience.filters.splice(groupIndex, 1);
            }
        };

        vm.deleteFilter = function(groupIndex, filterIndex) {
            vm.targetAudience.filters[groupIndex].splice(filterIndex, 1);
        };

        vm.addNewFilter = function (groupIndex) {
            if (!vm.canAddNewFilter(groupIndex)) {
                vm.markAllFieldsTouched();
                return;
            }
            if (vm.targetAudience.filters[groupIndex]) {
                vm.targetAudience.filters[groupIndex].push({
                    field: null,
                    operator: null,
                    value: null
                });
            }

            $timeout(function() {
                var filters = document.querySelectorAll('#group-' + groupIndex + ' .list-group-item');
                if (filters.length > 0) {
                    filters[filters.length - 1].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                }
            });
        };


        function validateAgeFilter() {
            var hasAgeFilter = vm.targetAudience.filters.some(function (
                group
            ) {
                return group.some(function (filter) {
                    return filter.field === vm.fieldLabels.AGE;
                });
            });

            if (hasAgeFilter) {
                toastr.error(
                    $translate.instant(
                        'campaign.new.public-info.toast.invalid-age'
                    )
                );
            }
        }

        vm.createAudience = function () {
            if (vm.targetAudienceForm.$invalid) {
                validateAgeFilter();
                vm.markAllFieldsTouched();
                return;
            }
            vm.isSubmitting = true;

            var originalValues = mapValuesToOriginal(vm.targetAudience.filters);
            var targetAudienceData = {
                name: vm.targetAudience.name,
                filters: originalValues
            };

            var createdItem = null;
            TargetAudienceService.createTargetAudience(targetAudienceData).then(function (response) {
                createdItem = {
                    value: response.data.id,
                    label: response.data.name,
                    subtitle: response.data.description ? response.data.description : ''
                };
                $uibModalInstance.close(createdItem);
                vm.isSubmitting = false;
                toastr.success($translate.instant("campaign.new.public-info.toast.create-success"));
            }, function (){
                vm.isSubmitting = false;
                toastr.error($translate.instant("campaign.new.public-info.toast.create-error"));
            });
        };

        vm.choiceProp = function (groupIndex, propIndex, prop) {
            if (!vm.targetAudience.filters[groupIndex]) {
                vm.targetAudience.filters[groupIndex] = [];
            }


            if (vm.targetAudience.filters[groupIndex][propIndex]) {
                vm.targetAudience.filters[groupIndex][propIndex].group = prop;
            } else {
                vm.targetAudience.filters[groupIndex].push({
                    field: null,
                    operator: null,
                    value: null,
                    startValue: null,
                    endValue: null,
                    group: prop
                });
            }
        };

    }
})();
